document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;

  const menuDrawer = document.querySelector('[data-ma-drawer]');
  const menuOverlay = document.querySelector('[data-ma-overlay]');
  const menuOpen = document.querySelector('[data-ma-menu-open]');
  const menuClose = document.querySelector('[data-ma-menu-close]');

  const cartDrawer = document.querySelector('[data-ma-cart-drawer]');
  const cartOverlay = document.querySelector('[data-ma-cart-overlay]');
  const cartOpenButtons = document.querySelectorAll('[data-ma-cart-open]');
  const cartClose = document.querySelector('[data-ma-cart-close]');


  const countryPicker = document.querySelector('.ma-country-picker');
  const countryTrigger = document.querySelector('[data-ma-country-open]');
  const localizationForm = document.querySelector('.ma-country-picker');
  const countryInput = localizationForm?.querySelector('[data-ma-country-input]');
  const languageInput = localizationForm?.querySelector('[data-ma-language-input]');
  const localizationOptions = localizationForm?.querySelectorAll('[data-ma-localization-option]') || [];

  localizationOptions.forEach(option => {
    option.addEventListener('click', () => {
      if (!localizationForm || !countryInput || !languageInput) return;
      countryInput.value = option.dataset.countryCode || countryInput.value;
      languageInput.value = option.dataset.languageCode || languageInput.value;
      try { localStorage.setItem('gs_language', languageInput.value); localStorage.setItem('gs_country', countryInput.value); } catch (e) {}
      option.setAttribute('aria-busy', 'true');
      localizationForm.submit();
    });
  });

  const closeCountryPicker = () => {
    countryPicker?.classList.remove('is-open');
    countryTrigger?.setAttribute('aria-expanded', 'false');
  };

  countryTrigger?.addEventListener('click', (event) => {
    event.stopPropagation();
    const next = !countryPicker?.classList.contains('is-open');
    closeCountryPicker();
    if (next) {
      countryPicker?.classList.add('is-open');
      countryTrigger.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('click', (event) => {
    if (countryPicker && !countryPicker.contains(event.target)) closeCountryPicker();
  });

  const moneyFormat = (window.MaisonAlpine && window.MaisonAlpine.moneyFormat) || '€{{amount}}';
  const shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const cartJsonUrl = `${shopifyRoot}cart.js`;
  const cartChangeUrl = `${shopifyRoot}cart/change.js`;

  const formatMoney = (cents) => {
    const numeric = Number(cents || 0);
    const amount = (numeric / 100).toFixed(2);
    const comma = amount.replace('.', ',');

    if (moneyFormat.includes('{{amount_with_comma_separator}}')) {
      return moneyFormat.replace('{{amount_with_comma_separator}}', comma);
    }
    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }
    return `${comma} €`;
  };

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);

  const lock = () => root.classList.add('ma-lock');

  const unlockIfClear = () => {
    if (!document.querySelector('.ma-drawer.is-open, .ma-cart-drawer.is-open')) {
      root.classList.remove('ma-lock');
    }
  };

  function closeMenu() {
    if (!menuDrawer || !menuOverlay) return;
    menuDrawer.classList.remove('is-open');
    menuOverlay.classList.remove('is-open');
    menuOpen?.setAttribute('aria-expanded', 'false');
    setTimeout(unlockIfClear, 280);
  }

  function closeCart() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOpenButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    setTimeout(unlockIfClear, 300);
  }

  function openMenu() {
    closeCart();
    if (!menuDrawer || !menuOverlay) return;
    menuDrawer.classList.add('is-open');
    menuOverlay.classList.add('is-open');
    menuOpen?.setAttribute('aria-expanded', 'true');
    lock();
  }

  function openCart() {
    closeMenu();
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOpenButtons.forEach(btn => btn.setAttribute('aria-expanded', 'true'));
    lock();
  }

  menuOpen?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);

  cartOpenButtons.forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();
      openCart();
    });
  });

  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeMenu();
      closeCart();
      closeCountryPicker();
    }
  });

  const cartBody = document.querySelector('[data-ma-cart-body]');
  const cartFooter = document.querySelector('[data-ma-cart-footer]');
  const cartTotal = document.querySelector('[data-ma-cart-total]');
  const headingCount = document.querySelector('[data-ma-cart-heading-count]');

  const updateHeaderCount = itemCount => {
    let badge = document.querySelector('.ma-cart-count');
    const trigger = document.querySelector('.ma-cart-trigger');

    if (!itemCount) {
      badge?.remove();
      return;
    }

    if (!badge && trigger) {
      badge = document.createElement('span');
      badge.className = 'ma-cart-count';
      trigger.appendChild(badge);
    }

    if (badge) {
      badge.textContent = itemCount;
      badge.style.display = 'grid';
    }
  };

  const getLocalizedProductUrl = () => {
    const language = String(window.GlacierShift?.language || 'fr').toLowerCase();
    if (language.startsWith('de')) return 'https://bwrszc-iy.myshopify.com/de-de/products/reaktive-skijacke';
    if (language.startsWith('en')) return 'https://bwrszc-iy.myshopify.com/en-us/products/reactive-ski-jacket';
    return 'https://bwrszc-iy.myshopify.com/products/veste-ski-reactive';
  };

  const renderCart = cart => {
    if (!cartBody) return;

    if (headingCount) headingCount.textContent = `(${cart.item_count})`;
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    updateHeaderCount(cart.item_count);

    if (!cart.item_count) {
      cartBody.innerHTML = `
        <div class="ma-cart-empty">
          <div class="ma-cart-empty__icon">
            <svg viewBox="0 0 32 32" aria-hidden="true">
              <path d="M7 10h18l-1.4 18H8.4L7 10Z"/>
              <path d="M11 10V8a5 5 0 0 1 10 0v2"/>
            </svg>
          </div>
          <h3>Votre panier est vide</h3>
          <p>Votre prochaine aventure commence ici.</p>
          <a href="${getLocalizedProductUrl()}" class="ma-button">Découvrir les vestes</a>
        </div>`;
      if (cartFooter) cartFooter.hidden = true;
      return;
    }

    if (cartFooter) cartFooter.hidden = false;

    cartBody.innerHTML = `
      <div class="ma-cart-items">
        ${cart.items.map(item => `
          <article class="ma-cart-line" data-ma-cart-line data-key="${escapeHtml(item.key)}">
            <a class="ma-cart-line__media" href="${escapeHtml(item.url)}">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
            </a>

            <div class="ma-cart-line__info">
              <div class="ma-cart-line__top">
                <div>
                  <a href="${escapeHtml(item.url)}" class="ma-cart-line__title">
                    ${escapeHtml(item.product_title)}
                  </a>
                  ${item.variant_title ? `<div class="ma-cart-line__variant">${escapeHtml(item.variant_title)}</div>` : ''}
                </div>

                <button type="button" class="ma-cart-line__remove" data-ma-remove aria-label="Supprimer">
                  ×
                </button>
              </div>

              <div class="ma-cart-line__bottom">
                <div class="ma-qty">
                  <button type="button" data-ma-qty-minus aria-label="Diminuer">−</button>
                  <span data-ma-qty>${item.quantity}</span>
                  <button type="button" data-ma-qty-plus aria-label="Augmenter">+</button>
                </div>

                <strong>${formatMoney(item.final_line_price)}</strong>
              </div>
            </div>
          </article>
        `).join('')}
      </div>`;
  };

  const getCart = async () => {
    const response = await fetch(cartJsonUrl, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Impossible de charger le panier.');
    return response.json();
  };

  const changeLine = async (key, quantity) => {
    const response = await fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });

    if (!response.ok) throw new Error('Impossible de modifier le panier.');
    return response.json();
  };

  cartDrawer?.addEventListener('click', async event => {
    const line = event.target.closest('[data-ma-cart-line]');
    if (!line) return;

    const key = line.dataset.key;
    const quantity = Number(line.querySelector('[data-ma-qty]')?.textContent || 1);

    let nextQuantity = null;

    if (event.target.closest('[data-ma-qty-plus]')) nextQuantity = quantity + 1;
    if (event.target.closest('[data-ma-qty-minus]')) nextQuantity = Math.max(0, quantity - 1);
    if (event.target.closest('[data-ma-remove]')) nextQuantity = 0;

    if (nextQuantity === null) return;

    try {
      line.style.opacity = '.5';
      line.style.pointerEvents = 'none';
      const cart = await changeLine(key, nextQuantity);
      renderCart(cart);
    } catch (error) {
      console.error('[NØRD cart]', error);
      line.style.opacity = '';
      line.style.pointerEvents = '';
    }
  });

  document.addEventListener('cart:refresh', async () => {
    try {
      renderCart(await getCart());
    } catch (error) {
      console.error('[NØRD cart]', error);
    }
  });
});
